export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";